<template>
	<div class="product">
		<filterBar :proCategoryList="proCategoryList" @ProCategoryID="setProCategoryID" @searchName="setSearchName">
		</filterBar>
		<el-card class="productList" shadow="hover">
			<div slot="header" class="clearfix">
				<span>产品列表({{productCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="AddBtnProduct()">新增产品
				</el-button>
			</div>
			<el-table :data="showDate()" style="width: 100%;margin-bottom: 20px;">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" class="demo-table-expand">
							<el-form-item label="产品ID">
								<span>{{ props.row.id }}</span>
							</el-form-item>
							<el-form-item label="产品名称">
								<span>{{ props.row.name }}</span>
							</el-form-item>
							<el-form-item label="描述">
								<span>{{ props.row.introduce }}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="categoryID" label="缩略图" width="160">
					<template slot-scope="scope">
						<el-image :src="$http.fileUrl+scope.row.img" style="height: 100px;width: 100%;"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="产品名称">
					<template slot-scope="scope">
						<div v-html="scope.row.name.replace(searchName,'<font  color=\'red\'>'+searchName+'</font>')">
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sceneName" label="场景名称" width="100">
				</el-table-column>
				<el-table-column prop="categoryID" label="所属分类" width="100">
					<template slot-scope="scope">
						{{selectCateName(scope.row.categoryID)}}
					</template>
				</el-table-column>
				<el-table-column prop="modelCount" label="模块数量" width="100">
				</el-table-column>
				<el-table-column prop="resourceCount" label="资源数量" width="100">
				</el-table-column>
				<el-table-column label="授权学院" v-if="getUserInfo.roleID==1" width="100">
					<template slot-scope="scope">
						{{scope.row.schoolCount}}个
						<el-button size="small" circle icon="el-icon-edit"
							@click="authSchoolVisible=true;productModel=scope.row"></el-button>
					</template>
				</el-table-column>
				<el-table-column label="序号(降序排列)" width="210">
					<template slot-scope="scope">
						<el-input-number v-model="scope.row.orderIndex" :step="1" step-strictly
							@change="setProductOrderIndex(scope.row)"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="上传时间" sortable width="180">
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button size="mini" style="margin-right: 10px;" icon="el-icon-edit" @click="edit(scope.row)">
							编辑</el-button>
						<el-popconfirm title="确定要删除吗" @confirm="delProduct(scope.row)">
							<el-button size="mini" type="danger" icon="el-icon-delete" slot="reference">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="productCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</el-card>
		<edit @before-Close='editProduct' :type="type" :productModel="productModel" :outerVisible="outerVisible"
			:proCategoryList="proCategoryList"></edit>
		<auth-school :outerVisible="authSchoolVisible" @before-Close="editProduct" :objdata="productModel">
		</auth-school>
	</div>
</template>

<script>
	import filterBar from './product/filterBar.vue'
	import edit from './product/edit.vue'
	import authSchool from './product/authSchool.vue'
	import {
		mapGetters
	} from 'vuex'
	export default {
		data() {
			return {
				page_size: 10,
				page_current: 1,
				productCount: 0,
				ProCategoryID: '',
				proCategoryList: [],
				proList: [],
				outerVisible: false,
				productModel: {
					id: '1',
					name: '',
					categoryID: '',
					introduce: '',
					img: ''
				},
				type: 'Add',
				authSchoolVisible: false,
				searchName: ''
			}
		},
		created() {
			this.loadproCategoryData()
			this.loadproList()
		},
		components: {
			filterBar,
			edit,
			authSchool
		},
		computed: {
			...mapGetters(['getUserInfo'])
		},
		methods: {
			showDate() {
				let list = this.proList.filter(item => item.name.search(this.searchName) > -1 && item.categoryID.search(
					this.ProCategoryID) > -1)
				this.productCount = list.length
				return list.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
			},
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			loadproCategoryData() {
				this.$http.get('api/Product/GetProduct_Categorys').then(res => {
					this.proCategoryList = res.data.data
				})
			},
			loadproList() {
				this.$http.get('api/Product/GetProducts').then(res => {
					this.proList = res.data.data
				})
			},
			selectCateName(val) {
				let CateName = ''
				this.proCategoryList.map(a => {
					if (a.id == val) {
						CateName = a.name
					}
				})
				return CateName
			},
			AddBtnProduct() {
				this.type = 'Add'
				this.productModel = {}
				this.outerVisible = true
			},
			delProduct(val) {
				if (val.schoolCount > 0) {
					this.$message({
						message: '请先取消学院授权，否则无法删除',
						type: 'info'
					})
				} else {
					this.$http.get('api/Product/DelProduct/' + val.id).then(res => {
						if (res.data.code == '1') {
							this.$message({
								message: "删除成功",
								type: 'success'
							})
							this.loadproList()
						}
					})
				}
			},
			setProductOrderIndex(val) {
				this.$http.get('api/Product/SetProducts_OrderIndex/' + val.id + '/' + val.orderIndex).then(res => {
					if (res.data.code == 1) {
						this.$message({
							message: res.data.message,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						})
					}
				})
			},
			edit(val) {
				this.productModel = val
				// this.productModel.img = this.$http.fileUrl + this.productModel.img
				this.type = 'Up'
				this.outerVisible = true
			},
			editProduct(val) {
				this.outerVisible = false
				this.authSchoolVisible = false
				if (val == true) {
					this.loadproList()
				}
			},
			setProCategoryID(val) {
				this.ProCategoryID = val
			},
			setSearchName(val) {
				this.searchName = val
				this.page_current = 1
			}
		}
	}
</script>

<style lang="scss">
	.product {
		.productList {
			margin-top: 20px;
		}

		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}

	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 100%;
	}
</style>
